<template>
  <div id="waitlist-modal" class="grid-enabled">
    <div class="close-modal" @click="$root.$emit('closeModal')">
      <img src="@/assets/icons/close.svg" />
    </div>
    <waitlist-form class="modalContent" :market="market" :homeType="homeType"></waitlist-form>
  </div>
</template>

<script>
import waitlistForm from '@/components/Forms/WaitlistForm.vue'

export default {
  name: 'WaitListModal',
  props: {
    market: {
      type: Object,
      default: () => ({}),
    },
    homeType: {
      type: String,
      default: ' ',
    },
  },
  components: {
    waitlistForm,
  },
}
</script>
